import {FC, Ref} from "react";
import {Textarea, TextareaProps} from "@mantine/core";
import {colors} from "@/theme";


const ScTextAreaControl: FC<{innerRef?: Ref<any>, showCountMax?: number} & TextareaProps> = (inputProps: any) => {

    const {innerRef, showCountMax, value, error, styles, ...restProps} = inputProps;

    const count = showCountMax ? (value ?? '').toString().length : 0;
    const isOverMax = !!showCountMax && count > showCountMax;

    return (
        <div style={{position: 'relative'}}>
            <Textarea
                mt={'sm'}
                value={value}
                error={error}
                styles={isOverMax && !error ? {
                    ...styles,
                    input: {
                        ...(styles?.input as object),
                        borderColor: colors.mantineErrorOrange,
                    },
                } : styles}
                {...restProps}
                ref={innerRef}
            />
            {showCountMax ? (
                // Absolutely positioned so it always sits on the bottom-right of whichever
                // line is currently last in the wrapper — the error line when one is shown,
                // otherwise the field itself.
                <span style={{
                    position: 'absolute',
                    right: 4,
                    bottom: error ? 0 : -17,
                    fontSize: 'var(--mantine-font-size-xs)',
                    color: isOverMax ? colors.mantineErrorOrange : 'var(--mantine-color-dimmed)',
                    fontWeight: isOverMax ? 600 : 400,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none',
                }}>
                    {count}/{showCountMax}
                </span>
            ) : null}
        </div>
    );
};

export default ScTextAreaControl;
